import { render, staticRenderFns } from "./LockWhite.vue?vue&type=template&id=55f0d825&scoped=true"
var script = {}
import style0 from "./LockWhite.vue?vue&type=style&index=0&id=55f0d825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f0d825",
  null
  
)

export default component.exports